import react, { useEffect, useState } from 'react'
import { Form, Input, Button, notification, Card } from 'antd';
import FormItem from '../../components/FormItem'
import './styles.less'
import { useDispatch } from 'react-redux';
import Request from '../../request';
import _ from 'lodash'
import { getUrlParams } from '../../routes';
const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 16,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 8,
    },
};

const Demo = (props) => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [loader, setLoader] = useState(false)
    const [params, setParams] = useState(false)

    const onFinish = async (valData) => {
        if (params?.id) {
            setLoader(true)
            let { user, token, success, message, data } = await Request.updateAsteriskServer(params?.id, { ...valData })
            // console.log(success, data, message)
            setLoader(false)
            if (success) {
                notification.success({
                    message: message
                })
            } else {
                notification.error({
                    message: message || "Failed"
                })
            }
        } else {
            setLoader(true)
            let { user, token, success, message, data } = await Request.addAsteriskServer(valData)
            setLoader(false)
            if (success) {
                notification.success({
                    message: message
                })
                form.resetFields()
            } else {
                notification.error({
                    message: message || "Failed"
                })
            }
        }
    }

    const requiredRule = [{ required: true, message: 'Please input field' }]
    const apiFunction = async () => {
        let params = getUrlParams('editAsteriskServer', window.location.pathname)
        if (params?.id) {
            setParams(params)
            let { user, token, success, message, data } = await Request.getAsteriskServer(params?.id)
            if (success) {
                let mainData = data
                form.setFieldsValue({ ...mainData })
            } else {
                notification.error({
                    message: message || "Failed"
                })
            }

        }
    }

    useEffect(async () => {
        apiFunction()
    }, [props])
    return (
        <Card style={{ flex: 1 }}>
            <Form
                {...layout}
                // size="small"
                form={form}
                onFinish={onFinish}
            >
                <FormItem
                    label={'Server IP'}
                    name="serverip"
                    rules={requiredRule}
                />
                  <FormItem
                    label={'Asterisk Url'}
                    name="asterisk_url"
                    rules={requiredRule}
                />
                <FormItem
                    label={'Ari User'}
                    name="ariuser"
                    rules={requiredRule}
                />
                {!params && <FormItem
                    label={'Ari Password'}
                    name="aripassword"
                    inputType="PASSWORD"
                    rules={requiredRule}
                />}
                <FormItem
                    label={'Agi User'}
                    name="agiuser"
                    rules={requiredRule}
                />
                {!params && <FormItem
                    label={'Agi Password'}
                    name="agipassword"
                    inputType="PASSWORD"
                    rules={requiredRule}
                />}
                <FormItem
                    label={'Ami User'}
                    name="amiuser"
                    rules={requiredRule}
                />
                {!params && <FormItem
                    label={'Ami Password'}
                    name="amipassword"
                    inputType="PASSWORD"
                    rules={requiredRule}
                />}
                <FormItem
                    label={'Max Extension'}
                    name="maxextension"
                    width={200}
                    inputType={'NUMBER'}
                    rules={requiredRule}
                />
                 <FormItem
                    label={'FQDN'}
                    name="fqdn"
                    rules={requiredRule}
                />
                 <FormItem
                    label={'Endpoint Socket Port'}
                    name="endpoint_socket_port"
                    rules={requiredRule}
                />
                <FormItem
                    label={'Active'}
                    inputType={'SWITCH'}
                    name="active"
                />
                <FormItem
                    label={'Shareable'}
                    inputType={'SWITCH'}
                    name="shareable"
                />
                <div >
                    <FormItem
                        inputType="BUTTON"
                        tailLayout={tailLayout}
                        type="primary"
                        buttonStyle={{ width: 180, marginTop: 10 }}
                        loading={loader}
                        title="SUBMIT"
                        htmlType="submit" />
                </div>
            </Form>
        </Card >
    );
};

export default Demo